import { InputNumber } from 'primereact/inputnumber';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldErrorMessage } from '@features/campaigns/builder/components/FormFields/common/FieldErrorMessage/FieldErrorMessage';
import { BillingFormFieldTypes } from '@features/campaigns/details/components/FormFields/FieldTypes';
import fieldStyles from '@shared/components/FormFields/FormFields.module.scss';
import { i18nNameSpace, NUMBER_FORMAT_LOCALE } from '@shared/consts/i18n.ts';

export function FieldRealBudget() {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const { control } = useFormContext();

  return (
    <div className={fieldStyles.fieldWrapper}>
      <label htmlFor={BillingFormFieldTypes.REAL_BUDGET} className={fieldStyles.fieldLabel}>
        {t('page.billingForm.realBudgetField.label')}
      </label>

      <Controller
        name={BillingFormFieldTypes.REAL_BUDGET}
        control={control}
        render={({ field, formState: { errors } }) => {
          return (
            <>
              <span className='p-input-icon-left'>
                <i className='pi pi-euro' />
                <InputNumber
                  {...field}
                  id={BillingFormFieldTypes.REAL_BUDGET}
                  locale={NUMBER_FORMAT_LOCALE}
                  onChange={(event) => field.onChange(event.value)}
                  placeholder={t('page.billingForm.realBudgetField.placeholder')}
                  data-testid='field-real-budget'
                  min={0}
                  maxLength={7}
                />
              </span>
              {errors?.[BillingFormFieldTypes.REAL_BUDGET] && (
                <FieldErrorMessage fieldErrorData={errors} fieldName={BillingFormFieldTypes.REAL_BUDGET} />
              )}
            </>
          );
        }}
      />
    </div>
  );
}
